
import React from 'react';
import PresetManagement from 'features/administrativo/components/PresetManagement';

const ConfiguracoesPresets = () => {
  return <PresetManagement />;
};

export default ConfiguracoesPresets;
